import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';
import checklistForm from '../checklistForm';
import coreDataForm from './coreDataForm';
import anamnesisForm from './anamnesisForm';
import policeMeasureForm from './policeMeasureForm';
import importantDataForm from './importantDataForm';
import onwardPlacementForm from './onwardPlacementForm';
import casePresentationDataForm from '../commonForms/casePresentation';

const counselingCenterForms: Form<Client>[] = [
  checklistForm,
  coreDataForm,
  anamnesisForm,
  policeMeasureForm,
  importantDataForm,
  onwardPlacementForm,
  casePresentationDataForm,
];

export default counselingCenterForms;
